// removed by extract-text-webpack-plugin
module.exports = {"radio-group-container":"RadioGroup__radio-group-container","radioGroupContainer":"RadioGroup__radio-group-container","container-row":"RadioGroup__container-row","containerRow":"RadioGroup__container-row","container-column":"RadioGroup__container-column","containerColumn":"RadioGroup__container-column"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/RadioGroup/RadioGroup.css
// module id = 1226
// module chunks = 8